import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-zoom-in",
  templateUrl: "./med-icon-zoom-in.component.html",
})
export class MedIconZoomInComponent extends SvgMixinComponent {}
